// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailM":"M_wave2DetailM__KnzbR"};